import { Button } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { IoClose } from "react-icons/io5";
import {
  adminDeleteAdditionalShift,
  adminDeleteBreak,
} from "../../../network/admin";
import { modalTypes } from "../../../types/workingHoure";
import DeleteModal from "../../common/DeleteModal";

type Props = {
  data: any;
  date: any;
  isLocationClose: any;
  isSalonHasVacation: any;
  handleOpenModalToAddToShift: (shiftId: number, modalType: modalTypes) => void;
  config: {
    teamMemberId: number;
    locationId: number;
  };
};

const DayWorkingHours = ({
  date,
  data,
  isLocationClose,
  handleOpenModalToAddToShift,
  config,
  isSalonHasVacation,
}: Props) => {
  const [selectedShiftToDelete, setSelectedShiftToDelete] = useState<
    number | null
  >(null);
  const [deletedItem, setDeletedItem] = useState<
    "break" | "additionalShift" | null
  >(null);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  function formatHour(time: any) {
    const formattedTime = dayjs(time, "HH:mm:ss");
    const hour = +formattedTime.hour();
    const minute = +formattedTime.minute();
    const isPM = +hour >= 12;
    const normalizedHour = +hour % 12 || 12; // Converts hour to 12-hour format, makes 0 hour to 12 (for 12 AM)

    return {
      formatted: `${normalizedHour}:${minute.toString().padStart(2, "0")}`, // Ensures minutes are two digits
      period: isPM ? "pm" : "am",
    };
  }
  console.log(data);
  return !isLocationClose ? (
    !isSalonHasVacation ? (
      <>
        <DeleteModal
          visible={openDeleteModal}
          onClose={() => {
            setOpenDeleteModal(false);
          }}
          onDelete={
            deletedItem === "break"
              ? adminDeleteBreak
              : adminDeleteAdditionalShift
          }
          data={{ ...config, deletedItemId: selectedShiftToDelete }}
          confirmationHeader={
            "Are you sure you want to delete this " + deletedItem === "break"
              ? "Break ?"
              : "Additional Shift ?"
          }
          confirmationText={""}
          queryKey={"TeamMember"} // Pass the correct key here
          successMessage={
            deletedItem === "break"
              ? "Break"
              : "Additional Shift " + "deleted successfully"
          }
          afterDelete={() => {
            setOpenDeleteModal(false);
            setSelectedShiftToDelete(null);
            setDeletedItem(null);
          }}
        />
        <div className="bg-[#EEF0FF] p-[10px] rounded-lg w-full text-sm  h-full 4xl:grid 4xl:grid-cols-4 text-center items-center gap-3">
          <span className="max-3xl:text-xs whitespace-nowrap">{date}</span>
          <div className="flex items-center w-full h-full gap-2 overflow-auto 2xl:col-span-2">
            {data.start_time && (
              <div className="text-xs w-full max-w-[120px] min-w-[120px] h-full max-3xl:my-1">
                <div className="grid w-full h-full gap-1 p-1 text-white rounded-lg bg-color-primary">
                  <div className="font-semibold capitalize">
                    {data?.shift_type} Shift
                  </div>
                  <div>
                    {(() => {
                      const startTime = formatHour(data.start_time);
                      const endTime = formatHour(data.end_time);
                      return (
                        <>
                          {startTime.formatted}
                          <span className="text-[8px]">
                            {startTime.period}
                          </span>{" "}
                          <span className="mr-1">-</span>
                          {endTime.formatted}
                          <span className="text-[8px]">{endTime.period}</span>
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            )}

            {data?.additional_shift?.map((e: any) => (
              <div className="text-xs w-full h-full min-w-[120px] relative flex items-center gap-4 overflow-auto max-3xl:my-1">
                <div className="p-1 rounded-lg bg-[#CF953D] max-w-[120px] h-full w-full text-white grid gap-1">
                  <IoClose
                    className="absolute text-base cursor-pointer text-color-danger w-fit top-1 left-1"
                    onClick={() => {
                      setOpenDeleteModal(true);
                      setSelectedShiftToDelete(e.id);
                      setDeletedItem("additionalShift");
                    }}
                  />
                  <div className="font-semibold capitalize">Overtime</div>
                  <div>
                    {(() => {
                      const startTime = formatHour(e.start_time);
                      const endTime = formatHour(e.end_time);

                      return (
                        <>
                          {startTime.formatted}
                          <span className="text-[8px]">
                            {startTime.period}
                          </span>{" "}
                          <span className="mr-1">-</span>
                          {endTime.formatted}
                          <span className="text-[8px]">{endTime.period}</span>
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            ))}
            {data?.breaks?.map((e: any) => (
              <div className="text-xs w-full min-w-[120px] max-w-[120px] h-full max-3xl:my-1">
                <div className="p-1 rounded-lg bg-[#CFCFE2] h-full relative w-full text-white grid gap-1">
                  <IoClose
                    className="absolute text-base cursor-pointer text-color-danger w-fit top-1 left-1"
                    onClick={() => {
                      setOpenDeleteModal(true);
                      setSelectedShiftToDelete(e.id);
                      setDeletedItem("break");
                    }}
                  />

                  <div className="font-semibold capitalize">Break</div>
                  <div>
                    {(() => {
                      const startTime = formatHour(e.from);
                      const endTime = formatHour(e.to);
                      console.log(
                        startTime.formatted,
                        startTime.period,
                        "mazen"
                      );
                      return (
                        <>
                          {startTime.formatted}
                          <span className="text-[8px]">
                            {startTime.period}
                          </span>{" "}
                          <span className="mr-1">-</span>
                          {endTime.formatted}
                          <span className="text-[8px]">{endTime.period}</span>
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="flex flex-col w-full h-full col-start-4 gap-1 text-xs font-semibold text-left rounded-lg text-color-primary">
            <Button
              type="primary"
              className="rounded-lg bg-[#eef0ff] text-color-primary !h-fit !p-0 !m-0 !min-h-[20px] !text-xs justify-start flex"
              onClick={() => handleOpenModalToAddToShift(data?.id, "AddShifts")}
            >
              + Shift
            </Button>
            <Button
              disabled={!data.start_time}
              type="primary"
              className="rounded-lg bg-[#eef0ff] text-color-primary !h-fit !p-0 !m-0 !min-h-[20px] !text-xs justify-start flex"
              onClick={() =>
                handleOpenModalToAddToShift(data?.date, "AddAdditionalShift")
              }
            >
              + Overtime
            </Button>
            <Button
              type="primary"
              disabled={!data.start_time}
              className="rounded-lg bg-[#eef0ff] text-color-primary !h-fit !p-0 !m-0 !min-h-[20px] !text-xs justify-start flex"
              onClick={() => handleOpenModalToAddToShift(data?.id, "AddBreak")}
            >
              + Day Break
            </Button>
          </div>
        </div>
      </>
    ) : (
      <div className="bg-[#CFCFE2] py-2 px-4 rounded-lg w-full text-sm  h-full flex text-center items-center justify-between">
        <span className="w-full whitespace-nowrap max-3xl:text-xs">{date}</span>
        <div>
          <span className="text-xs font-medium text-[#9999A7]">Break</span>
        </div>
      </div>
    )
  ) : (
    <div className="bg-[#EEF0FF] text-color-gray p-[10px] rounded-lg flex text-sm  h-full text-center justify-between w-full items-center gap-3">
      <div className="max-3xl:text-xs">{date}</div>
      <div>close</div>
    </div>
  );
};

export default DayWorkingHours;
